var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentaries = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Camera-Studio--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Camera Studio Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.51 13a1.21 1.21 0 0 0 -1.13 -0.07l-2.73 1.14a0.25 0.25 0 0 0 -0.15 0.23v5.42a0.25 0.25 0 0 0 0.15 0.23l2.73 1.14A1.12 1.12 0 0 0 24 20v-6a1.19 1.19 0 0 0 -0.49 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.5h14s1.5 0 1.5 1.5v8s0 1.5 -1.5 1.5h-14S1 22.5 1 21v-8s0 -1.5 1.5 -1.5",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6a4.5 4.5 0 1 0 9 0 4.5 4.5 0 1 0 -9 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5a3 3 0 1 0 6 0 3 3 0 1 0 -6 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentaries);
export default ForwardRef;